<script>
import compoment from '@/components/draggable/SmartComponents/basicComponents/Sinput/SInputPreview'
export default {
  name: 'SDIdentityPreview',
  extends: compoment
}
</script>
